import { render, staticRenderFns } from "./imgCircle.vue?vue&type=template&id=2d74b0dd&scoped=true"
import script from "./imgCircle.vue?vue&type=script&lang=js"
export * from "./imgCircle.vue?vue&type=script&lang=js"
import style0 from "./imgCircle.vue?vue&type=style&index=0&id=2d74b0dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d74b0dd",
  null
  
)

export default component.exports